<template>
  <div class="disk-other">
    <div class="disk" id="disk" ref="disk"></div>
    <div class="disk-box">
      <div class="date">
        <div>
          <span>min</span>
          <span>max</span>
          <span>mvg</span>
          <span>curant*</span>
        </div>
      </div>
      <div class="date-box">
        <div class="left">
          <span style="background: #9ff0ff"></span>
          <span>tital_read(MBps)</span>
        </div>
        <div class="right">
          <span>{{this.needData.tital_read.Min}}MBps</span>
          <span>{{this.needData.tital_read.Max}}MBps</span>
          <span>{{this.needData.tital_read.Mvg}}MBps</span>
          <span>{{this.needData.tital_read.Curant}}MBps</span>
        </div>
      </div>

      <div class="date-box">
        <div class="left">
          <span style="background: #00d8ff"></span>
          <span>tital_write(MBps)</span>
        </div>
        <div class="right">
          <span>{{this.needData.tital_write.Min}}MBps</span>
          <span>{{this.needData.tital_write.Max}}MBps</span>
          <span>{{this.needData.tital_write.Mvg}}MBps</span>
          <span>{{this.needData.tital_write.Curant}}MBps</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props:['needData'],
  mounted() {
    // setTimeout(() => {
    //   this.disk(this.needData);
    // },200);
     this.disk(this.needData);
  },
  // watch: {
  //   'needData'() {
  //     this.disk(this.needData);
  //   },
  // },
  methods: {
    disk(param) {
      let myEchart = this.$echarts.init(document.getElementById("disk"));
      // console.log(param);
       var date = []; 
      param.DateTime.forEach((item )=> {
        date.push(item.substring(item.length-5));
      });

      // var base = +new Date(2020, 0, 0);
      // var oneDay = 24 * 3600 * 1000;
      // var date = [];

      // var data = [Math.random() * 200];
      // var data2 = [Math.random() * 500];
      // var data3 = [Math.random() * 700];
      // var data4 = [Math.random() * 900];

      // for (var i = 1; i < 367; i++) {
      //   var now = new Date((base += oneDay));
      //   date.push(
      //     [now.getFullYear(), now.getMonth() + 1, now.getDate()].join("/")
      //   );
      //   data.push(Math.round((Math.random() - 0.5) * 20 + data[i - 1]));
      //   data2.push(Math.round((Math.random() - 0.5) * 20 + data2[i - 1]));
      //   data3.push(Math.round((Math.random() - 0.5) * 20 + data3[i - 1]));
      //   data4.push(Math.round((Math.random() - 0.5) * 20 + data4[i - 1]));
      // }

      let option = {
        grid: {
          top: "12%",
          left: "8%",
          bottom: "35%",
          right: "5%",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: date,
          axisTick: {
            show: false,
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "#526775",
            },
          },
        },
        yAxis: {
          type: "value",
          name: "(MBps)",
          nameGap: 10,
          nameTextStyle: {
            padding: [0, 40, 0, 0],
          },
          boundaryGap: [0, "100%"],
          splitLine: {
            show: true,
            lineStyle: {
              color: "#526775",
              type: "dashed",
            },
          },
        },
        series: [
          {
            name: "2020预算",
            type: "line",
            smooth: true,
            stack: "",
            symbol: "none",
            sampling: "average",
            lineStyle: {
              color: "#00d7fe",
              width: 1,
            },
            itemStyle: {
              color: "#CA76C4",
              normal: {
                color: "#00d7fe",
                lineStyle: {
                  color: "#00d7fe",
                  width: 1,
                },
                areaStyle: {
                  //color: '#94C9EC'
                  color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: "rgba(0,215,254,0)",
                    },
                    {
                      offset: 1,
                      color: "rgba(0,215,254,0.8)",
                    },
                  ]),
                },
              },
              markPoint: {
                itemStyle: {
                  normal: {
                    color: "red",
                  },
                },
              },
            },
            data: param.Data1,
          },
          {
            name: "2020预算",
            type: "line",
            smooth: true,
            stack: "",
            symbol: "none",
            sampling: "average",
            lineStyle: {
              color: "#00d7fe",
              width: 1,
            },
            itemStyle: {
              color: "#CA76C4",
              normal: {
                color: "#00d7fe",
                lineStyle: {
                  color: "#00d7fe",
                  width: 1,
                },
                areaStyle: {
                  //color: '#94C9EC'
                  color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                    {
                      offset: 0,
                      color: "rgba(0,215,254,0)",
                    },
                    {
                      offset: 1,
                      color: "rgba(0,215,254,0.8)",
                    },
                  ]),
                },
              },
              markPoint: {
                itemStyle: {
                  normal: {
                    color: "red",
                  },
                },
              },
            },
            data: param.Data2,
          },
        ],
      };
      myEchart.setOption(option);
      window.addEventListener("resize", () => {
        myEchart.resize();
      });
    },
  },
};
</script>

<style scoped>
.disk-other {
  width: 100%;
  height: 100%;
  position: relative;
}
.disk {
  width: 100%;
  height: 100%;
}

.disk-box {
  width: 95%;
  height: 7.4vh;
  position: absolute;
  bottom: 0;
  left: 3%;
}
.disk-box .date {
  width: 100%;
  height: 1.6vh;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  color: #00e4ff;
  font-size: 0.6vw;
}

.disk-box .date div {
  width: 54%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  
}
.disk-box .date div span {
  height: 100%;
  margin-right: .8vw;
  /* transform: scale(0.8); */
  line-height: 1vh;
}
.disk-box .date div span:nth-child(4) {
 /* margin-left: .5vh; */
 /* margin-right:0; */
}

.disk-box .date-box {
  width: 100%;
  height: 2.3vh;
  background: url("../../assets/img/74.png");
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.6vw;
  margin-bottom: 0.5vh;
}

.disk-box .date-box .left {
  width: 22.5%;
  height: 100%;
  display: flex;
  align-items: center;
  font-size: 0.6vw;
  justify-content: space-between;
  margin-left: 1vw;
}

.disk-box .date-box .left span:nth-child(1) {
  width: 1.45vw;
  height: 0.7vh;
  background: red;
}
.disk-box .date-box .left span:nth-child(2) {
  color: #aebfc4;
}

.disk-box .date-box .right {
  width: 48%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #aebfc4;
  margin-right: 1vw;
}
.disk-box .date-box .right span {
  margin-left: .5vw;
}
.disk-box .date-box .right span:nth-child(1) {
  margin-left: 0;
}
</style>


